import axios from "axios";

const state = () => ({
  report: [],
  error: "",
  loading: false,
});

const mutations = {
  SET_REPORT(state, report) {
    state.report = report;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};

const getters = {
  getReport: (state) => {
    return state.report;
  },
  getError: (state) => {
    return state.error;
  },
  isLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async generateReport({ commit }, payload) {
    commit("SET_LOADING", true);
    const url =
      process.env.VUE_APP_API_URL +
      `/tm/courses/kpis/${payload.startDate}/${payload.endDate}`;

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.post(url, { ids: payload.ids }, config);
      commit("SET_REPORT", response.data);
      commit("SET_ERROR", "");
    } catch (error) {
      console.log(error.response?.data?.message);
      commit("SET_ERROR", "Failed to generate kpi report.");
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
